<template>
  <span>{{ computedIndex }}</span>
</template>

<script>
export default {
  props: {
    // zero-based index of an item
    index: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      default: 1
    },
    itemsPerPage: {
      type: Number,
      required: true
    },
    isLoading: {
      type: Boolean
    }
  },
  data () {
    return {
      prevPage: this.currentPage
    }
  },
  computed: {
    computedIndex () {
      const {
        index,
        currentPage,
        prevPage,
        itemsPerPage,
        isLoading
      } = this

      let page = currentPage

      if (currentPage && itemsPerPage) {
        if (isLoading) {
          page = prevPage
        }

        return itemsPerPage * (page - 1) + index + 1
      }

      return this.index + 1
    }
  },
  watch: {
    isLoading (value) {
      if (!value) {
        this.prevPage = this.currentPage
      }
    }
  }
}
</script>
